import {isAxiosError} from "axios";
import {toast} from "sonner";

const recent = new Map<string, number>();
const DEDUPLICATION_MS = 3_000;

export function errorDescription(error: unknown): string {
    if (!isAxiosError(error)) return "Bitte versuche es erneut.";
    if (error.code === "ECONNABORTED") return "Die Anfrage hat zu lange gedauert. Bitte versuche es erneut.";
    if (!error.response) return "Der Server ist nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.";
    switch (error.response.status) {
        case 400: return "Die Anfrage konnte nicht verarbeitet werden.";
        case 401: return "Deine Anmeldung ist abgelaufen. Bitte melde dich erneut an.";
        case 403: return "Du hast dafür keine Berechtigung.";
        case 404: return "Der angeforderte Eintrag wurde nicht gefunden.";
        case 409: return "Die Aktion steht im Konflikt mit dem aktuellen Datenstand.";
        case 413: return "Die Datei ist zu groß.";
        case 429: return "Zu viele Anfragen. Bitte versuche es später erneut.";
        default: return error.response.status >= 500
            ? "Auf dem Server ist ein Fehler aufgetreten. Bitte versuche es später erneut."
            : "Bitte versuche es erneut.";
    }
}

export function notifyError(error: unknown, message = "Aktion fehlgeschlagen"): void {
    // Session expiry is handled by AuthProvider, including navigation to login.
    if (isAxiosError(error) && error.response?.status === 401) return;
    const description = errorDescription(error);
    const key = `${message}:${description}`;
    const now = Date.now();
    if (now - (recent.get(key) ?? -Infinity) < DEDUPLICATION_MS) return;
    recent.set(key, now);
    if (recent.size > 100) {
        for (const [entry, time] of recent) if (now - time >= DEDUPLICATION_MS) recent.delete(entry);
    }
    toast.error(message, {description});
}
